// React
import type { LoaderFunctionArgs } from 'react-router-dom';
import type { RouteRecord } from 'vite-react-ssg';

// Views
import Page, { pageLoader } from '@/views/Page/Page';

// Types
import type { CmsRouteEntry } from '@/utils/cmsRoutesData';

// Utils
import { getSlug } from '@/utils/localeSlug';
import { withMediaVariants } from '@/utils/media/withMediaVariants';

export const buildNestedRoutes = (pages: CmsRouteEntry[]): RouteRecord[] => {
  const routes: RouteRecord[] = [];

  // Slug nettoyé (sans locale) → slug tel que stocké dans le CMS
  const cmsSlugByPath = new Map(pages.map(({ slug }) => [getSlug(slug), slug]));

  /** Le loader charge la page de l'URL complète (pas celle de sa route). */
  const loader = withMediaVariants(({ request }: LoaderFunctionArgs) => {
    const url = new URL(request.url);
    const path = getSlug(decodeURIComponent(url.pathname));
    return pageLoader({ request, cmsSlug: cmsSlugByPath.get(path) });
  });

  pages.forEach(({ slug, breadcrumb }) => {
    getSlug(slug).split('/').filter(Boolean).reduce((currentLevel, segment, index, segments) => {
      const isLastSegment = index === segments.length - 1;

      let route = currentLevel.find(r => r.path === segment);

      if (!route) {
        route = { path: segment, children: [] };
        currentLevel.push(route);
      }

      if (isLastSegment) {
        Object.assign(route, {
          Component: () => <Page key={slug} />,
          loader,
          handle: { breadcrumb },
        });
      }

      return route.children || [];
    }, routes);
  });

  return routes;
};
